import { Component } from '@angular/core';

@Component({
    selector: 'zwi-embed-logo',
    imports: [],
    templateUrl: './embed-logo.component.html',
    styleUrl: './embed-logo.component.scss'
})
export class EmbedLogoComponent {

}
